import { EImageType } from '@shared/pipes/image.pipe';
import { htmlUrls } from '@shared/utils/router-paths';
import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ChallengeAchievementModel } from '@app/pages/challenges/models/challenge-achievement-model';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/module/shared.module';

@Component({
  selector: 'app-pick-challenge-dialog',
  templateUrl: './pick-challenge-dialog.component.html',
  styleUrls: ['./pick-challenge-dialog.component.scss'],
  imports: [
    SharedModule,
    RouterModule,
    MatDialogModule,
  ]
})
export class PickChallengeDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<PickChallengeDialogComponent>>(MatDialogRef);
  data = inject<{
    challenge: ChallengeAchievementModel;
  }>(MAT_DIALOG_DATA);


  routes = htmlUrls;
  text!: string;
  imageType = EImageType;

  ngOnInit(): void {
    this.text = `شما به ${this.data.challenge.title} پیوستید.`
  }

}
